var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-half"},[_c('search-form')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }